<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner9.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>公司介绍</li>
            </ul>
            <h3 class="tab_title">公司简介</h3>
            <p>士模微电子由国际知名专家领衔，以高性能ADC/DAC为技术核心，聚焦工业级和汽车级信号链芯片的设计和销售。产品线覆盖高精度和高速ADC、DAC、放大器、基准和LDO，为工业、能源、汽车和通信等领域提供高性能信号链产品解决方案。依托资深的研发、运营、质量、营销和客户支持团队，士模微电子坚持全正向设计并熟稔产品制造工艺，保障国产自主可控。</p>
            <!-- <p>士模微电子由国际知名专家领衔，专注于工业级信号链芯片的设计和销售，以高性能ADC/DAC芯片为技术核心，为客户提供丰富的信号链芯片产品以及SoC级解决方案。产品线全面覆盖高性能ΔΣ/SAR/Pipeline ADC、DAC、放大器、基准和LDO，并已导入高铁、电力、工控、仪器仪表等领域头部客户。
依托资深的研发、运营、质量、营销和客户支持团队，士模微电子坚持全正向设计并熟稔foundry工艺，保障国产自主可控，为客户提供高可靠高性能的产品和优质的服务。</p> -->
            <!-- <p>士模微电子专注于高性能模拟信号链芯片的设计和销售，以高性能ADC/DAC芯片为技术核心，聚焦工业自动化、能源、医疗、仪器仪表和汽车电子等领域，为客户提供丰富的信号链芯片产品以及SoC级解决方案。公司团队由国际知名专家领衔，并完整覆盖研发、运营、质量、营销和客户支持。目前公司高性能ADC/DAC、放大器、基准源、LDO等产品线已经实现产品量产，实测性能指标在同类产品中处于领先地位。</p> -->
            <!-- <p>士模微电子专注于高性能模拟信号链芯片的设计和销售，以高性能ADC/DAC芯片为技术核心，聚焦工业自动化、能源、医疗、仪器仪表和汽车电子等领域，为客户提供丰富的信号链芯片产品以及SoC级解决方案。公司团队由国际知名专家领衔，并完整覆盖研发、运营、质量、营销和客户支持。目前公司高性能ADC/DAC、放大器、基准源产品线已经实现产品量产，实测性能指标在同类产品中处于领先地位。</p> -->
            <!-- <br /> -->
            <!-- <p>士模微电子将依托技术领先优势，为客户提供高可靠高性能的产品和优质的服务，成为国内高性能模拟信号链芯片行业先行者。</p> -->
            <br />
            <!-- <h3 class="tab_title">公司资质</h3> -->
            <img style="margin:20px 0" src="../../assets/img29.jpg" alt="" />
            <!-- <h3 class="tab_title">投资伙伴</h3> -->
        </div>
        <!-- <div class="swiper_wrap anTransform" style="width:1300px;margin:0 auto;overflow: hidden;">
                <swiper id="media" class="homeSwiper" :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, index) in swiperList" :key="index">
                    <img :src="item.coverImage" alt="" />
                </swiper-slide>
            </swiper>
            <div class="fleft bg"></div>
            <div class="fright bg"></div>
        </div> -->
    </div>
</template>
<script>
import {backPage} from '@/utils/common'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
export default {
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 4.5,
                slidesPerColumn: 2,
                spaceBetween: 10,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                // autoplay: {
                //     delay: 1000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: true,
                // },
                
            },
            swiperList: [
                { coverImage: require('../../assets/logo/logo1.png') },
                { coverImage: require('../../assets/logo/logo2.png') },
                { coverImage: require('../../assets/logo/logo3.png') },
                { coverImage: require('../../assets/logo/logo4.png') },
                { coverImage: require('../../assets/logo/logo5.png') },
                { coverImage: require('../../assets/logo/logo6.png') },
                { coverImage: require('../../assets/logo/logo7.png') },
                { coverImage: require('../../assets/logo/logo8.png') },
                { coverImage: require('../../assets/logo/logo9.png') },
                { coverImage: require('../../assets/logo/logo10.png') },
                { coverImage: require('../../assets/logo/logo11.png') },
                { coverImage: require('../../assets/logo/logo12.png') },
                { coverImage: require('../../assets/logo/logo13.png') },
                { coverImage: require('../../assets/logo/logo14.png') },
            ]
        }
    },
    mounted(){
        // document.getElementsByClassName('homeSwiper')[0].removeAttribute('overflow')
        // this.$refs.mySwiper.removeClass('swiper-container')
    },
    methods:{
        backPage
    }
}
</script>
<style lang="scss" scoped>
.title {
    border-left: 10px solid #d60e4c;
    line-height: 32px;
    text-indent: 30px;
    font-weight: bold;
    font-size: 36px;
    margin: 30px 0;
}

p {
    line-height: 32px;
    font-size: 16px;
}

.swiper_wrap {
    position: relative;

    .bg {
        height: 100%;
        position: absolute;
        width: 150px;
        top: 0;
        z-index: 999;
    }

    .bg.fleft {
        background-image: linear-gradient(to right, #eeeeee, transparent);
        left: 0;
    }

    .bg.fright {
        background-image: linear-gradient(to left, #eeeeee, transparent);
        right: 0;
    }

}
#media{
    animation:rolling 10s infinite linear;
}
#media:hover{
    animation-play-state:paused;
}
@keyframes rolling{
    0%{
        transform: translateX(0);
    }
    100%{
        transform: translateX(-800px);
    }
}
.homeSwiper{
    overflow: initial !important;
}
</style>


// WEBPACK FOOTER //
// src/views/about/index.vue